<template>
  <div id="changePass">
    <div class="head-title">
      <span class="head-text">修改密码</span>
    </div>
    <div class="box">
      <div class="form-box">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="账号名">
            <el-input v-model="form.username" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="form.pass" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input v-model="form.pass2" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="loading"
              style="margin-left:50px;"
              type="primary"
              @click="onSubmit"
            >确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      serve: this.$store.state.serve,
      token: this.$cookies.get("shop_token"),
      form: {
        username: ""
      }
    };
  },
  created() {
    this.showUserInfo();
    this.$store.state.shop_top = 0;
    this.$store.state.shop_left = "修改密码";
  },
  methods: {
    showUserInfo() {
      var where = {
        token: this.token
      };
      this.axios
        .get(this.serve + "shop/show_user_info", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.form = data.data;
          } else {
            this.$alerts.error("请求失败", this.$message);
          }
        });
    },
    onSubmit() {
      this.loading = true;
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };

      const formData = new FormData();
      formData.append("token", this.token);
      formData.append("pass", this.form.pass);
      formData.append("pass2", this.form.pass2);

      this.axios
        .post(this.serve + "shop/change_password", formData, config)
        .then(res => {
          window.console.log(res);
          if (res.data.status == "success") {
            this.loading = false;
            this.$alerts.success('修改成功' ,this.$message)
          }else if(res.data.status == 'error'){
            this.loading = false;
            this.$alerts.error(res.data.msg ,this.$message)
          }
        });
    }
  }
};
</script>
<style lang="scss">
#changePass {
  min-height: 500px;
  .head-title {
    width: 1060px;
    height: 46px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 46px;
    text-align: left;
  }
  .head-text {
    margin-left: 16px;
  }
  .box {
    width: 1060px;
    height: 600px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-box {
    width: 300px;
  }
}
</style>